import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" };
const _hoisted_2 = {
    key: 0,
    class: "h6 mb-0 py-40 text-center text-gray-500"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = {
    key: 0,
    class: "h6 mb-0 py-40 text-center text-gray-500"
};
const _hoisted_5 = {
    key: 1,
    class: "c-qa-list mb-0 ps-0"
};
const _hoisted_6 = { class: "mb-3" };
const _hoisted_7 = { class: "mb-3" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "mb-4" };
const _hoisted_11 = { class: "text-end" };
const _hoisted_12 = ["disabled"];
const _hoisted_13 = ["disabled"];
import CommentItem from '@vue/components/comment/CommentItem.vue';
import { onMounted, ref, watch } from 'vue';
import { BModal } from 'bootstrap-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LessonCommentApp',
    setup(__props) {
        const lessonId = u.data('lessonId');
        const totalComment = u.data('totalComment');
        const ownedLesson = u.data('ownedLesson');
        const comments = ref([]);
        const replies = ref([]);
        const nextCommentOffset = ref(0);
        const modalShow = ref(false);
        const showMoreBtn = ref(false);
        const title = ref('發表問題');
        const lessonSectionOrder = u.data('lessonSectionOrder');
        const isEdit = ref(false);
        const segmentOptions = ref([
            { text: '- 選擇章節 -', value: 0 }
        ]);
        const editingComment = ref({
            title: '',
            segmentId: 0,
            content: '',
            id: null
        });
        const loading = ref(false);
        function prepareSegmentOption() {
            lessonSectionOrder.forEach((chapter, i) => {
                chapter.forEach((section, j) => {
                    segmentOptions.value.push({
                        'text': `第 ${i + 1} 章．第 ${j + 1} 節 ` + section.title,
                        'value': section.id
                    });
                });
            });
        }
        async function prepareCommentList() {
            const res = await u.$http.get('@ajax_lesson/prepareMoreComment', {
                params: {
                    lesson_id: lessonId,
                    limit: 5,
                    offset: 0,
                }
            });
            comments.value = res.data.data.comments;
            nextCommentOffset.value = comments.value.length;
            Object.keys(res.data.data.replies).forEach((key) => {
                replies.value[key] = res.data.data.replies[key];
            });
        }
        function toggleMoreCommentButton() {
            if (totalComment <= 0) {
                showMoreBtn.value = false;
                return;
            }
            showMoreBtn.value = nextCommentOffset.value + 1 < totalComment;
        }
        async function prepareMoreComment() {
            const res = await u.$http.get('@ajax_lesson/prepareMoreComment', {
                params: {
                    lesson_id: lessonId,
                    limit: 5,
                    offset: nextCommentOffset.value,
                }
            });
            comments.value.push(...res.data.data.comments);
            nextCommentOffset.value = comments.value.length;
            Object.keys(res.data.data.replies).forEach((key) => {
                replies.value[key] = res.data.data.replies[key];
            });
            toggleMoreCommentButton();
        }
        onMounted(async () => {
            await prepareCommentList();
            toggleMoreCommentButton();
            prepareSegmentOption();
        });
        async function editComment(v) {
            title.value = '編輯問題';
            editingComment.value = {
                title: v.title,
                segmentId: v.targetId,
                content: v.content,
                id: v.id
            };
            modalShow.value = true;
            isEdit.value = true;
        }
        async function postComment() {
            try {
                loading.value = true;
                const res = await u.$http.post('@ajax_lesson/addComment', {
                    title: editingComment.value.title,
                    content: editingComment.value.content,
                    id: editingComment.value.id,
                    segment_id: editingComment.value.segmentId,
                });
                if (!editingComment.value.id) {
                    comments.value.push(res.data.data);
                }
                else {
                    comments.value = comments.value.map((comment) => {
                        if (comment.id === editingComment.value.id) {
                            return { ...res.data.data };
                        }
                        else {
                            return comment;
                        }
                    });
                }
                modalShow.value = false;
            }
            catch (e) {
                swal(e.message);
            }
            finally {
                loading.value = false;
            }
        }
        watch(modalShow, (newValue) => {
            if (!newValue) {
                editingComment.value = {
                    title: '',
                    segmentId: 0,
                    content: '',
                    id: null
                };
                isEdit.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h5 mb-0 text-gray-700" }, " 問題討論 ", -1)),
                        (_unref(ownedLesson))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-primary btn-sm",
                                onClick: _cache[0] || (_cache[0] = ($event) => (modalShow.value = !modalShow.value))
                            }, _cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "fa-solid fa-pen-to-square me-1" }, null, -1),
                                _createTextVNode(" 發表問題 ")
                            ])))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    (!_unref(ownedLesson))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock-keyhole me-12" }, null, -1),
                            _createTextVNode(" 購買課程後即可查看內容 ")
                        ])))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (comments.value.length <= 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 無作業內容 "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (item) => {
                                        return (_openBlock(), _createBlock(CommentItem, {
                                            key: item.id,
                                            comment: item,
                                            replies: replies.value,
                                            onEdit: editComment
                                        }, null, 8, ["comment", "replies"]));
                                    }), 128)),
                                    (showMoreBtn.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-outline-primary mt-4 w-100",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (prepareMoreComment()))
                                        }, " 查看更多 "))
                                        : _createCommentVNode("", true)
                                ]))
                        ]))
                ]),
                _createVNode(_unref(BModal), {
                    modelValue: modalShow.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((modalShow).value = $event)),
                    "no-footer": ""
                }, {
                    title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(title.value), 1)
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                                for: "comment-title",
                                class: "form-label"
                            }, " 標題 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "comment-title",
                                name: "comment[title]",
                                placeholder: "問題主旨",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editingComment.value.title) = $event))
                            }, null, 512), [
                                [_vModelText, editingComment.value.title]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", {
                                for: "comment-segment",
                                class: "form-label"
                            }, " 章節 ", -1)),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                id: "comment-segment",
                                name: "comment[segment]",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editingComment.value.segmentId) = $event)),
                                disabled: isEdit.value
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentOptions.value, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        value: option.value
                                    }, _toDisplayString(option.text), 9, _hoisted_9));
                                }), 256))
                            ], 8, _hoisted_8), [
                                [_vModelSelect, editingComment.value.segmentId]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", {
                                for: "comment-content",
                                class: "form-label"
                            }, "內容", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                id: "comment-content",
                                rows: "3",
                                name: "comment[content]",
                                placeholder: "輸入提問內容",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((editingComment.value.content) = $event))
                            }, null, 512), [
                                [_vModelText, editingComment.value.content]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "c-form-btn btn btn-outline-primary",
                                onClick: _cache[5] || (_cache[5] = ($event) => (modalShow.value = !modalShow.value)),
                                disabled: loading.value
                            }, " 取消 ", 8, _hoisted_12),
                            _createElementVNode("button", {
                                class: "c-form-btn btn btn-primary",
                                onClick: postComment,
                                disabled: loading.value
                            }, " 送出 ", 8, _hoisted_13)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
